<!-- WCAG 4.1.3: Toast status messages with ARIA -->
<p-toast role="status" aria-live="polite" aria-atomic="true"></p-toast>

<main
  class="main-run-wrapper surface-ground min-h-screen p-3 md:p-6 flex justify-content-center"
  role="main"
  aria-labelledby="checklist-run-title"
>
  @if (isLoading()) {
    <div
      class="flex flex-column align-items-center justify-content-center w-full"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <p-progress-spinner strokeWidth="3" aria-hidden="true"></p-progress-spinner>
      <p class="text-xl text-500 mt-3 font-medium">Caricamento checklist...</p>
    </div>
  }

  @if (!isLoading() && checklist(); as data) {
    <div
      class="checklist-run-card card shadow-2 w-full max-w-6xl surface-card border-round-xl p-4 md:p-6 animate-fadein"
    >
      <!-- WCAG 2.4.6: H1 as main page heading (not H2) -->
      <header class="text-center mb-6">
        <h1 id="checklist-run-title" class="text-4xl font-bold m-0 text-primary">
          {{ data.name }}
        </h1>
        <p class="checklist-subtitle text-secondary mt-2 text-lg font-medium">
          Informazioni della checklist richiesta
        </p>
      </header>

      <!-- File Upload Requests Section -->
      <!-- WCAG 2.4.6: H2 follows H1 (was H3) -->
      <section class="mt-6" aria-labelledby="checklist-documents-title">
        <h2
          id="checklist-documents-title"
          class="checklist-section-title text-2xl font-bold mb-4 text-900"
        >
          <i class="pi pi-file-pdf mr-3 text-primary" aria-hidden="true"></i>Documenti Richiesti
        </h2>

        @if (!data.fileUploadRequests || data.fileUploadRequests.length === 0) {
          <div
            class="empty-state text-center p-6 border-round-lg border-2 border-dashed border-200"
            role="status"
            aria-live="polite"
          >
            <i class="pi pi-inbox text-6xl text-300 block mb-3" aria-hidden="true"></i>
            <p class="text-xl text-500 font-medium">Nessun documento richiesto</p>
          </div>
        }

        <div role="list" aria-label="Elenco documenti richiesti">
          @for (item of data.fileUploadRequests; track item.id || $index; let i = $index) {
            <div
              class="file-request-item p-3 mb-3 border-round-lg border-1 border-200 transition-all hover:shadow-2 hover:border-primary"
              role="listitem"
              [attr.aria-labelledby]="'checklist-item-title-' + i"
              [attr.aria-describedby]="
                parseExtensions(item.allowedExtensions).length > 0
                  ? 'checklist-item-extensions-' + i
                  : null
              "
            >
              <div class="flex align-items-start gap-3">
                <div
                  class="request-position flex align-items-center justify-content-center flex-shrink-0"
                  [attr.aria-label]="'Documento richiesto numero ' + (i + 1)"
                >
                  {{ i + 1 }}
                </div>

                <div class="flex-grow-1">
                  <p
                    [attr.id]="'checklist-item-title-' + i"
                    class="file-request-title text-xl font-bold text-900 m-0 mb-2"
                  >
                    {{ item.text }}
                  </p>

                  @if (parseExtensions(item.allowedExtensions).length > 0) {
                    <div
                      class="item-tags mb-2"
                      [attr.id]="'checklist-item-extensions-' + i"
                      [attr.aria-label]="
                        'Estensioni consentite: ' +
                        parseExtensions(item.allowedExtensions).join(', ')
                      "
                    >
                      @for (type of parseExtensions(item.allowedExtensions); track type) {
                        <p-tag [value]="type" severity="secondary" [rounded]="true"></p-tag>
                      }
                    </div>
                  }

                  @if (item.templateFile) {
                    <a
                      [href]="item.templateFile"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="inline-flex align-items-center gap-2 text-primary font-semibold hover:underline text-base transition-colors"
                      [attr.aria-label]="
                        'Scarica template per ' + item.text + ' in una nuova scheda'
                      "
                      [attr.title]="'Scarica template per ' + item.text"
                    >
                      <i class="pi pi-download" aria-hidden="true"></i>
                      Scarica Template
                    </a>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </section>

      <!-- Close Button -->
      <div class="flex justify-content-end gap-3 mt-8 pt-5 border-top-1 border-100">
        <!-- WCAG 1.3.1: Use [attr.aria-label] binding instead of ariaLabel prop -->
        <p-button
          label="Chiudi Checklist"
          icon="pi pi-times-circle"
          severity="secondary"
          (click)="closeChecklist()"
          styleClass="shadow-2"
          [raised]="true"
          [attr.aria-label]="'Chiudi checklist e torna alla lista file checklist'"
        >
        </p-button>
      </div>
    </div>
  }
</main>
